import React from 'react';
import { times } from 'lodash-es';

import Skeleton from '../../../components/Skeleton';

export default {
  pageHeader: (
    <div className="publisher_page_header d-flex align-items-center mb-xs">
      <div className="flex-grow">
        <div className="mb-lg">
          <h2 className="text-lg">
            <Skeleton height={24} width={240} />
          </h2>
          <ul className="entity-details-list">
            <li className="v-a-t">
              <Skeleton height={14} width={64} />
            </li>
            <li className="v-a-t">
              <Skeleton height={14} width={80} />
            </li>
            <li className="v-a-t">
              <Skeleton height={14} width={80} />
            </li>
          </ul>
        </div>
        <h2 className="text-md">
          <Skeleton height={20} width={220} />
        </h2>
      </div>
      <Skeleton height={36} width={180} />
      <div className="m-l-xs">
        <Skeleton height={36} width={36} />
      </div>
    </div>
  ),
  kpiTile: (
    <div className="col-xxs-12 col-sm-6 col-lg-3 m-b p-t text-xxs-center">
      <Skeleton className="mx-auto" height={20} width={20} />
      <div className="m-t-xxs m-b-xxs">
        <Skeleton className="mx-auto" height={12} width={140} />
      </div>
      <div>
        <Skeleton className="mx-auto" height={32} width={120} />
      </div>
    </div>
  ),
  monetizationPanel: (
    <div className="d-flex flex-column w-100 mb-xs publisher_page_monetization__panel_skeleton">
      <div className="text-center">
        <Skeleton className="mx-auto" height={14} width={120} />
      </div>
      <div className="d-flex justify-content-center">
        <Skeleton height={220} width={240} borderRadius={120} />
      </div>
      <div className="mx-auto publisher_page_monetization__legend">
        {times(2).map((n) => (
          <div key={n} className="d-flex align-items-center p-a-xs">
            <Skeleton height={12} width="40%" />
            <div className="m-l-auto">
              <Skeleton height={16} width={80} />
            </div>
          </div>
        ))}
      </div>
    </div>
  ),
  chart: (
    <div className="card m-b-0">
      <h3 className="text-md m-b-lg">
        <Skeleton height={18} width={320} />
      </h3>
      <Skeleton height={280} />
    </div>
  ),
  sdksPanel: (
    <div className="panel m-b">
      <div className="panel-heading p-a-sm">
        <Skeleton height={16} width={200} />
      </div>
      <div className="panel-body p-a-sm">
        {times(4).map((n) => (
          <div key={n} className="d-flex align-items-center p-a-xxs">
            <Skeleton height={28} width={120} />
            <div className="m-l-auto publisher_page_sdks__skeleton_bar">
              <Skeleton height={12} />
            </div>
          </div>
        ))}
      </div>
    </div>
  ),
  companyInfo: (
    <div>
      <h3 className="text-md m-b-lg">
        <Skeleton height={20} width={200} />
      </h3>
      {times(8).map((n) => (
        <div key={n} className="d-flex p-a-xxs b-b">
          <Skeleton height={12} width={120} />
          <div className="m-l-auto publisher_page_company_contacts__skeleton_value">
            <Skeleton height={12} />
          </div>
        </div>
      ))}
    </div>
  ),
  keyContacts: (
    <div>
      <h3 className="text-md m-b-lg">
        <Skeleton height={20} width={160} />
      </h3>
      <div className="key-contacts">
        {times(3).map((n) => (
          <div key={n} className="contact-card p-a-sm b-b">
            <Skeleton height={48} width={48} borderRadius={24} />
            <div className="m-t-xs">
              <Skeleton height={14} width="60%" />
              <div className="m-t-xxs">
                <Skeleton height={12} width="40%" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  ),
};
